import { render, staticRenderFns } from "./yfkreport.vue?vue&type=template&id=2674d52a&scoped=true&"
import script from "./yfkreport.vue?vue&type=script&lang=js&"
export * from "./yfkreport.vue?vue&type=script&lang=js&"
import style1 from "./yfkreport.vue?vue&type=style&index=1&id=2674d52a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674d52a",
  null
  
)

export default component.exports